// Lazy background video: hydrate <source data-src> when the video nears the
// viewport, then play/pause it as it enters and leaves.
import { onReady } from '../utils/ready.js';

export function initLazyVideo() {
  function init() {
    var videos = [].slice.call(document.querySelectorAll('video[data-lazy-video]'));
    if (!videos.length) return;
    var reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;
    function hydrate(v) {
      if (v.dataset.lazyLoaded) return;
      var any = false;
      [].forEach.call(v.querySelectorAll('source[data-src]'), function (s) {
        var src = s.getAttribute('data-src');
        if (!src) return;
        s.src = src;
        s.removeAttribute('data-src');
        any = true;
      });
      if (!any) return;
      v.dataset.lazyLoaded = 'true';
      v.muted = true;
      v.loop = true;
      v.playsInline = true;
      v.addEventListener('playing', function () { v.classList.add('is-playing'); });
      v.addEventListener('pause', function () { v.classList.remove('is-playing'); });
      v.load();
    }
    function play(v) {
      hydrate(v);
      if (!v.dataset.lazyLoaded || reduced) return;
      var pr = v.play();
      if (pr && pr.catch) pr.catch(function () {});
    }
    function pause(v) {
      if (!v.paused) v.pause();
    }
    if (!('IntersectionObserver' in window)) {
      videos.forEach(play);
      return;
    }
    var units = videos.map(function (v) { return { v: v, t: v.parentElement || v }; });
    function unit(target) {
      for (var i = 0; i < units.length; i++) if (units[i].t === target) return units[i];
      return null;
    }
    var loader = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        var u = unit(e.target);
        if (!u || !e.isIntersecting) return;
        hydrate(u.v);
        loader.unobserve(e.target);
      });
    }, { rootMargin: '50% 0px' });
    var player = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        var u = unit(e.target);
        if (!u) return;
        if (e.isIntersecting && e.intersectionRatio >= 0.25) play(u.v);
        else pause(u.v);
      });
    }, { threshold: [0, 0.25] });
    units.forEach(function (u) {
      loader.observe(u.t);
      player.observe(u.t);
    });
  }

  onReady(init);
}
